import { DatePipe } from '@angular/common';
import { Component, EventEmitter, HostListener, Input, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute, Params } from '@angular/router';
import { AnnotationConstraints, ConnectorModel, DiagramComponent, DiagramModule, DiagramTools, DiagramTooltipModel, ImageModel, MarginModel, NodeConstraints, NodeModel, PaletteModel, SelectorConstraints, SelectorModel, SnapConstraints, SnapSettingsModel, ZoomOptions } from '@syncfusion/ej2-angular-diagrams';
import { forkJoin, Subscription } from 'rxjs';
import { GeneralService } from 'src/app/services/general.service';
import { LayoutService } from 'src/app/services/layout.service';
import { OperationRentalService } from 'src/app/services/Rentals.service';
import { customCurrencyPipe } from 'src/app/Shared/customCurrency.pipe';
import { ANGULAR_MODULES, SYNCFUSION_MODULES } from 'src/app/Shared/shared-imports';
import { SharedDataService } from 'src/app/Shared/SharedData.service';
import { WordReplacePipe } from 'src/app/Shared/word-replace.pipe';
import Swal from 'sweetalert2';

interface DateString {
  startDate: string;
}

@Component({
  selector: 'app-ops-rental-layout',
  standalone: true,
  imports: [ANGULAR_MODULES, SYNCFUSION_MODULES, DiagramModule, WordReplacePipe],
  templateUrl: './ops-rental-layout.component.html',
  styleUrl: './ops-rental-layout.component.scss'
})
export class OpsRentalLayoutComponent {
  public loaderIcon: Promise<boolean>;
  @ViewChild('diagram', { static: false })
  public diagram: DiagramComponent;
  private subscriptions: Subscription[] = [];
  layoutForm: FormGroup;
  defaultZoomFactor = 0;
  @Input() layoutParts: any;
  @Input() rentalType;
  @Input() LayoutData;
  @Output() selectedBoothsFromLayout = new EventEmitter<any>();
  @Output() CloseLayout = new EventEmitter<any>();
  @Output() removeBoothCharges = new EventEmitter<any>();
  allExistingBuilding = [];
  boothShapes;
  fontName;
  fontStyle;
  layoutImages;
  images = [];
  selectedNode = [];
  selectedBoothData = [];
  allBooths = [];
  partId;
  isDropdownOpen = false;
  public palettes?: PaletteModel[];
  connectors: ConnectorModel[];
  selectedItems: SelectorModel;
  symbolMargin: MarginModel;
  noboothSelected = true
  public snapSettings: SnapSettingsModel = {
    constraints: SnapConstraints.None,
  };
  tool: DiagramTools;
  vendorId;
  BoothNumber;
  BoothType;
  blinkingNode: string = '';
  categoryLegend = [];
  blinkInterval: any;
  selectedPartName = "";
  selectedBoothsForRental = [];
  public tooltip?: DiagramTooltipModel;
  constructor(private layoutService: LayoutService,
    private formbuilder: FormBuilder,
    private route: ActivatedRoute,
    private sharedDataService: SharedDataService,
    private datePipe: DatePipe,
    private generalService: GeneralService,
    private customCurrency: customCurrencyPipe,
    private operationRentalService: OperationRentalService) {
    this.layoutForm = this.formbuilder.group({
      layoutDiagramFilter: this.formbuilder.group({
        searchBooth: ['']
      })
    });
    this.tool = DiagramTools.SingleSelect;
    this.selectedItems = {
      constraints: SelectorConstraints.All &
        ~(SelectorConstraints.ResizeAll | SelectorConstraints.Rotate)
    };
    this.symbolMargin = { left: 15, right: 15, top: 15, bottom: 15 };
  }

  @HostListener('document:click', ['$event'])
  clickOutsideDropdown(event: MouseEvent): void {
    const legendDropDown = document.querySelector('.legendDropDown');
    const dropdownElement = document.querySelector('.custom-dropdown');
    if (!legendDropDown.contains(event.target as Node) && !dropdownElement.contains(event.target as Node) && ((document.querySelector('.legendDropDown') as HTMLElement).classList.contains('open'))) {
      this.isDropdownOpen = false;
    }
  }

  closeCategoryLegend() {
    this.isDropdownOpen = false;
  }

  stopPropagation(event: Event) {
    event.stopPropagation();
  }

  toggleDropdown() {
    if (!this.isDropdownOpen)
      (document.querySelector('.legendDropDown') as HTMLElement).classList.add('open');
    else
      (document.querySelector('.legendDropDown') as HTMLElement).classList.remove('open');
    this.isDropdownOpen = !this.isDropdownOpen;
  }

  ngOnInit(): void {
    console.log('inside layout')
    this.route.params.subscribe((params: Params) => {
      this.vendorId = params['id'];
    });
    this.partId = this.layoutParts;
    this.getParts();
    this.getProductCategories();
    this.getListOfValuesData();
    this.getImages();
  }

  getParts() {
    this.loaderIcon = Promise.resolve(true);
    const sub = this.layoutService.getParts().subscribe((res: any) => {
      if (res) {
        this.selectedPartName = this.selectedPartName = res.filter(e => e.PartId == this.partId)[0].PartDescription;
        this.loaderIcon = Promise.resolve(false);
      }
    }, err => {
      this.loaderIcon = Promise.resolve(false);
    });
    this.subscriptions.push(sub);
  }

  AddSelectedBoothsToGrid() {
    this.selectedBoothsFromLayout.emit(this.selectedBoothData);
  }

  deleteFromTemp(obj) {
    this.subscriptions.push(
      this.operationRentalService.deleteFromTemp(obj).subscribe((res: any) => {
      })
    );
  }

  closeLayoutForm() {
    if (this.selectedBoothsForRental.length > 0) {
      this.selectedBoothsForRental.forEach(ele => {
        if (this.rentalType == "D") {
          this.sharedDataService.dailyRentalSelectedDays.map(date => {
            const temp = {
              TempRecordNo: this.sharedDataService.tempRecordNo.toString(),
              BoothNo: ele.BoothNumber,
              StartDate: new Date(date),
              RentalType: 1
            }
            this.deleteFromTemp(temp);
          });
        }
        else if (this.rentalType === "CM" || this.rentalType === "CW") {
          const rentalTypeId = this.rentalType === "CM" ? 4 : 5;
          const temp = {
            TempRecordNo: this.LayoutData.tempRecordNo.toString(),
            BoothNo: ele.BoothNumber,
            StartDate: new Date(ele.StartDate),
            EndDate: new Date(ele.EndDate),
            RentalType: rentalTypeId,
            Sunday: ele.Sunday,
            Monday: ele.Monday,
            Tuesday: ele.Tuesday,
            Wednesday: ele.Wednesday,
            Thursday: ele.Thursday,
            Friday: ele.Friday,
            Saturday: ele.Saturday
          };
          this.deleteFromTemp(temp);
        }
      });
    }
    const delay = this.selectedBoothsForRental.length > 0 ? 400 : 0;
    setTimeout(() => this.CloseLayout.emit(), delay);
  }

  public created(args: Object): void {
    // fit the diagram to the page with respect to mode and region
    this.diagram.fitToPage({
      mode: 'Page',
      region: 'Content',
      margin: {
        bottom: 50
      },
      canZoomIn: true
    });
  }

  private createMarkedNode(nodeId: string, selectedNode: NodeModel): NodeModel {
    const width = selectedNode.width / 2;
    const height = selectedNode.height / 2;
    return {
      id: nodeId.replace("&", "_amper_") + "mark",
      offsetX: selectedNode.offsetX,
      offsetY: selectedNode.offsetY,
      width: width,
      height: height,
      shape: {
        type: "HTML",
        content: `<div style="width:${width}px; height:${height}px">
                  <svg width="100%" height="100%" xmlns="http://www.w3.org/2000/svg">
                    <line x1="0" y1="0" x2="100%" y2="100%" stroke="black" stroke-width="2"/>
                    <line x1="100%" y1="0" x2="0" y2="100%" stroke="black" stroke-width="2"/>
                  </svg>
                </div>`
      },
      constraints: NodeConstraints.Default & ~(NodeConstraints.Drag),
    };
  }

  private getSelectedDates(startDate: Date, endDate: Date, selectedDays: number[]): string[] {
    const selectedDates: string[] = [];
    const current = new Date(startDate);
    while (current <= endDate) {
      if (selectedDays.includes(current.getDay())) {
        selectedDates.push(this.datePipe.transform(current, 'MM/dd/yyyy')!);
      }
      current.setDate(current.getDate() + 1);
    }
    return selectedDates;
  }

  markSelectedBooths() {
    const rentalType = this.rentalType;

    if (rentalType === "D" && this.sharedDataService.dailyRentalSelectedBooths.length > 0) {
      this.sharedDataService.dailyRentalSelectedDays.forEach(date => {
        const rentalDate = this.datePipe.transform(date, 'MM/dd/yyyy');
        this.sharedDataService.dailyRentalSelectedBooths.forEach(element => {
          if (rentalDate === element.RentalDay) {
            const nodeId = `node_${element.BoothNumber}`;
            const selectedNode = this.diagram.getObject(nodeId) as NodeModel;
            if (selectedNode) {
              const node = this.createMarkedNode(nodeId, selectedNode);
              this.diagram.add(node);
            }
            const boothData = this.allBooths.find(e => e.BoothNumber === element.BoothNumber);
            if (boothData) {
              this.selectedBoothData.push({
                BoothNumber: boothData.BoothNumber,
                BoothType: boothData.BoothType,
                BoothTypeId: boothData.BoothTypeId,
              });
            }
          }
        });
      });
      this.noboothSelected = this.selectedBoothData.length === 0;
    }

    const isWeeklyOrMonthly = rentalType === "CW" || rentalType === "CM";
    if (isWeeklyOrMonthly) {
      const rentalBooths = rentalType === "CW"
        ? this.LayoutData.weeklyRentalSelectedBooths
        : this.LayoutData.monthlyRentalSelectedBooths;

      const selectedMarketDays = rentalType === "CW"
        ? this.LayoutData.weeklyRentalMarketDays
        : this.LayoutData.monthlyRentalMarketDays;

      const selectedDates = this.LayoutData.selectedDates;

      rentalBooths.forEach(element => {
        const start = new Date(rentalType === "CW" ? element.RentStartPeriod.split('-')[0] : element.RentalStartDate);
        const end = new Date(rentalType === "CW" ? element.RentEndPeriod.split('-')[1] : element.RentalEndDate);
        const dates = this.getSelectedDates(start, end, selectedMarketDays.map(d => d - 1));

        if (dates.some(date => selectedDates.includes(date))) {
          const nodeId = `node_${element.BoothNumber}`;
          const selectedNode = this.diagram.getObject(nodeId) as NodeModel;
          if (selectedNode) {
            const node = this.createMarkedNode(nodeId, selectedNode);
            this.diagram.add(node);
          }
        }
      });
    }
  }

  getProductCategories() {
    this.loaderIcon = Promise.resolve(true);
    this.subscriptions.push(this.operationRentalService.getProductCategories().subscribe((res: any) => {
      if (res) {
        res.map((el, i) => {
          const ob = {
            categoryName: el.CategoryDescription,
            color: this.convertColor(el.Color)
          }
          this.categoryLegend.push(JSON.parse(JSON.stringify(ob)));
        })
      }
    }, err => {
      this.loaderIcon = Promise.resolve(false);
    }));
  }

  bindBoothsToLayout(data) {
    this.loaderIcon = Promise.resolve(true);
    this.allBooths = data;
    if (data.length > 0) {
      for (const item of data) {
        var boothStatus = "Booked";
        switch (item.Status.toLowerCase()) {
          case "r": boothStatus = "Reserved"
            break;
          case "ro": boothStatus = "Reserved Only"
            break;
          case "a": boothStatus = "Available"
            break;
          case "ab": boothStatus = "Absentee Booking"
            break;
          default: boothStatus = "Booked"
            break;
        }
        if (boothStatus == 'Closed Out' || (item.Status.toLowerCase() == 'd' && !item.AccountReceiptId)) {
          //Booth closeout - do nothing
        }
        else {
          const fontColor = boothStatus.toLowerCase() == "reserved" ? "#fff" : "#000";
          const tooltipCaption = item.VendorId ? 'Vendor Id:' + item.MarketVendorId + ' Name: ' + item.VendorName + ' Type: ' + item.RentalType + ' Status: ' + boothStatus + ' Product: ' + item.ProductDescription + ' VendorBalance : ' + this.customCurrency.transform(((-1) * item.PriorBalance).toString()) + ' Booth Number: ' + item.BoothNumber + ' Booth Type: ' + item.BoothType + ' Booth Description: ' + item.BoothDescription : ' Booth Number: ' + item.BoothNumber + ' Booth Type: ' + item.BoothType + ' Booth Description: ' + item.BoothDescription;
          const nodeId = 'node_' + item.BoothNumber;
          const diagramNode: NodeModel = {
            id: nodeId,
            shape: {
              type: 'Basic',
              shape: this.boothShapes.filter(e => e.Id == item.ShapeId)[0]?.Name
            },
            style: {
              fill: this.convertColor(item.BackColor),
              strokeColor: this.convertColor(item.BorderColor),
              color: fontColor,
              strokeWidth: 1,
              fontSize: item.FontSize,
              textWrapping: 'Wrap',
              fontFamily: this.fontName.filter(e => e.Id == item.FontName)[0]?.Name
            },
            annotations:
              [{
                content: item.BoothNumber,
                style: {
                  fontSize: item.FontSize,
                  color: fontColor,
                  fontFamily: this.fontName.filter(e => e.Id == item.FontName)?.Name,
                  textWrapping: 'Wrap',
                  bold: this.fontStyle.filter(e => e.Id == item.FontStyle)[0]?.Name.toLowerCase().includes('bold'),
                  italic: this.fontStyle.filter(e => e.Id == item.FontStyle)[0]?.Name.toLowerCase().includes('italic')
                },

                constraints: AnnotationConstraints.ReadOnly
              }],
            tooltip: {
              content: tooltipCaption,
              position: 'TopCenter',
              relativeMode: 'Object',
            },
            width: item.Width * 3,
            height: item.Length * 3,
            addInfo: {
              allowDrag: true,
              name: 'booth',
              status: item.Status
            },
            constraints: NodeConstraints.Default & ~(NodeConstraints.Drag) | NodeConstraints.Tooltip,
            offsetX: item.LeftCoordinate,
            offsetY: item.TopCoordinate,
            rotateAngle: item.RotateAngle
          };
          this.diagram.add(diagramNode);
        }
      }
    }
    this.markSelectedBooths();
    this.loaderIcon = Promise.resolve(false);
  }

  getAllBoothsForLayout() {
    this.loaderIcon = Promise.resolve(true);
    if (this.rentalType == "D") {
      var obj;
      var rentalStartDate = this.sharedDataService.dailyRentalSelectedDays[0];
      var rentalDaysLength = this.sharedDataService.dailyRentalSelectedDays.length;
      const rentalStartDateYear = new Date(this.sharedDataService.dailyRentalSelectedDays[0]).getFullYear();
      const rentalStartDateMonth = new Date(this.sharedDataService.dailyRentalSelectedDays[0]).getMonth() + 1;
      const rentalStartDateYearMonth = `${rentalStartDateYear}${rentalStartDateMonth < 10 ? '0' : ''}${rentalStartDateMonth}`;
      var selectedMarketDays = [];
      rentalStartDate.getDay() == 0 ? selectedMarketDays.push(1) : 0;
      rentalStartDate.getDay() == 1 ? selectedMarketDays.push(2) : 0;
      rentalStartDate.getDay() == 2 ? selectedMarketDays.push(3) : 0;
      rentalStartDate.getDay() == 3 ? selectedMarketDays.push(4) : 0;
      rentalStartDate.getDay() == 4 ? selectedMarketDays.push(5) : 0;
      rentalStartDate.getDay() == 5 ? selectedMarketDays.push(6) : 0;
      rentalStartDate.getDay() == 6 ? selectedMarketDays.push(7) : 0;
      obj = {
        RentalStartDate: this.sharedDataService.dailyRentalSelectedDays[0],
        RentalEndDate: this.sharedDataService.dailyRentalSelectedDays[rentalDaysLength - 1],
        RentalYearMonth: rentalStartDateYearMonth,
        Monday: rentalStartDate.getDay() == 1 ? true : false,
        Tuesday: rentalStartDate.getDay() == 2 ? true : false,
        Wednesday: rentalStartDate.getDay() == 3 ? true : false,
        Thursday: rentalStartDate.getDay() == 4 ? true : false,
        Friday: rentalStartDate.getDay() == 5 ? true : false,
        Saturday: rentalStartDate.getDay() == 6 ? true : false,
        Sunday: rentalStartDate.getDay() == 0 ? true : false,
        MarketDays: selectedMarketDays.toString()
      }
      forkJoin({
        boothsList: this.operationRentalService.getAllBoothsForDailyRentalTypeLayout(this.partId, this.sharedDataService.dailyRentalSelectedDays),
      }).subscribe(({ boothsList }) => {
        let data = boothsList;
        this.bindBoothsToLayout(data);
        this.loaderIcon = Promise.resolve(false);
      });
    }
    else if (this.rentalType == "CM") {
      this.subscriptions.push(this.operationRentalService.getRentalSettings().subscribe((response: any) => {
        if (response) {
          const startParts = this.LayoutData.monthlyRentalStartDate.split(' ');
          const rentalStartDateYear = parseInt(startParts[1], 10);
          const rentalStartDateMonth = this.getMonthIndex(startParts[0]) + 1;
          const endParts = this.LayoutData.monthlyRentalEndDate.split(' ');
          const rentalEndDateYear = parseInt(endParts[1], 10);
          const rentalEndDateMonth = this.getMonthIndex(endParts[0]) + 1;
          const rentalStartDateYearMonth = `${rentalStartDateYear}${rentalStartDateMonth < 10 ? '0' : ''}${rentalStartDateMonth}`;
          const rentalEndDateYearMonth = `${rentalEndDateYear}${rentalEndDateMonth < 10 ? '0' : ''}${rentalEndDateMonth}`;
          var marketDays = '';
          this.LayoutData.monthlyRentalMarketDays.forEach(element => {
            marketDays = marketDays.concat(element) + ',';
          });
          var obj = {
            PartId: this.partId,
            RentalStartDate: new Date(this.LayoutData.RentalStartDate),
            RentalEndDate: new Date(this.LayoutData.RentalEndDate),
            FirstDayOfRentalStartWeek: new Date(this.LayoutData.RentalStartDate),
            FirstDayOfRentalEndWeek: new Date(this.LayoutData.RentalEndDate),
            RentalStartDateYearMonth: rentalStartDateYearMonth,
            RentalEndDateYearMonth: rentalEndDateYearMonth,
            MarketDays: marketDays.substring(0, marketDays.length - 1),
            WeeklyCombWeeklyReservationPeriod: response.WeeklyCombWeeklyReservationPeriod,
            MonthlyCombMonthlyReservationPeriod: response.MonthlyCombMonthlyReservationPeriod,
            RentalStartDateWeekDayNumber: new Date(rentalStartDateYear, rentalStartDateMonth - 1, 1).getDay(),
            AllowVendorVacation: false,
            Monday: this.LayoutData.Monday ? true : false,
            Tuesday: this.LayoutData.Tuesday ? true : false,
            Wednesday: this.LayoutData.Wednesday ? true : false,
            Thursday: this.LayoutData.Thursday ? true : false,
            Friday: this.LayoutData.Friday ? true : false,
            Saturday: this.LayoutData.Saturday ? true : false,
            Sunday: this.LayoutData.Sunday ? true : false,
          }
          this.subscriptions.push(this.operationRentalService.getALLBoothsForLayoutALLRentalTypes(obj).subscribe((response) => {
            let data = response;
            this.bindBoothsToLayout(data);
            this.loaderIcon = Promise.resolve(false);
          }, err => {
            this.loaderIcon = Promise.resolve(false);
          }));
        }
      }));
    }
  }

  async changeLayout() {
    this.diagram.clear();
    await this.getBuildingForLayout();
    await this.getImagesForLayout();
    await this.getAllBoothsForLayout();
    this.diagram.fitToPage();
    if (this.defaultZoomFactor) {
      let zoomOptions: ZoomOptions = {
        type: 'ZoomIn',
        zoomFactor: this.defaultZoomFactor
      };
      this.diagram.zoomTo(zoomOptions);
    }
  }

  async getListOfValuesData() {
    this.loaderIcon = Promise.resolve(true);
    forkJoin({
      boothShapes: this.generalService.getListOfValuesByType(1),
      fontName: this.generalService.getListOfValuesByType(2),
      fontStyle: this.generalService.getListOfValuesByType(3),
      layoutFonts: this.layoutService.getLayoutFonts()
    }).subscribe(async ({ boothShapes, fontName, fontStyle, layoutFonts }) => {
      this.boothShapes = boothShapes;
      this.fontName = fontName;
      this.fontStyle = fontStyle;
      if (layoutFonts) {
        this.defaultZoomFactor = layoutFonts.DefaultZoomFactor ?? 0;
      }
      await this.getAllBoothsForLayout();
      await this.getBuildingForLayout();
      await this.getImagesForLayout();
      this.diagram.fitToPage();
      if (this.defaultZoomFactor) {
        let zoomOptions: ZoomOptions = {
          type: 'ZoomIn',
          zoomFactor: this.defaultZoomFactor
        };
        this.diagram.zoomTo(zoomOptions);
      }
      this.loaderIcon = Promise.resolve(false);
    }, err => {
      this.loaderIcon = Promise.resolve(false);
    });
  }

  convertColor(colorValue: number): string {
    if (colorValue == 255 || colorValue == 65280 || colorValue == 0)
      return '#' + colorValue.toString(16).padStart(6, '0');
    else
      return '#' + colorValue.toString(16);
  }

  nodeMouseOver(event) {
    if (event.target) {
      const nodeId = event.target.id == "" ? 'node_' + event.target.innerHTML : event.target.id.replace('_content', '');
      const selectedNode = this.diagram.getObject(nodeId) as NodeModel;
      if (selectedNode) {
        var boothNo = selectedNode.id.replace('node_', '');
        var selectedBooth = this.allBooths.filter(e => e.BoothNumber == boothNo);
        this.BoothNumber = boothNo;
        this.BoothType = selectedBooth[0]?.BoothType;
      }
      else {
        this.BoothNumber = "";
        this.BoothType = "";
      }
    }
  }

  checkBoothSelectedBuyUserForDaily(dataFromTemp, selectedBooth) {
    this.sharedDataService.dailyRentalSelectedDays.forEach(date => {
      var Sunday = new Date(date).getDay() == 0 ? true : false;
      var Monday = new Date(date).getDay() == 1 ? true : false;
      var Tuesday = new Date(date).getDay() == 2 ? true : false;
      var Wednesday = new Date(date).getDay() == 3 ? true : false;
      var Thursday = new Date(date).getDay() == 4 ? true : false;
      var Friday = new Date(date).getDay() == 5 ? true : false;
      var Saturday = new Date(date).getDay() == 6 ? true : false;
      dataFromTemp.forEach(element => {
        if (this.datePipe.transform(date, 'MM/dd/yyyy') >= this.datePipe.transform(element.StartDate, 'MM/dd/yyyy')
          && this.datePipe.transform(date, 'MM/dd/yyyy') <= this.datePipe.transform(element.EndDate, 'MM/dd/yyyy') && element.TempRecordNo != this.sharedDataService.tempRecordNo
          && (element.Sunday == Sunday || element.Monday == Monday || element.Tuesday == Tuesday
            || element.Wednesday == Wednesday || element.Thursday == Thursday || element.Friday == Friday || element.Saturday == Saturday)) {
          if (element.BoothNo == selectedBooth[0]?.BoothNumber) {
            return true;
          }
        }
      });
    });
  }

  private getMarketDatesBetween(start: Date, end: Date, daysOfWeek: number[]): Date[] {
    const selectedDates: Date[] = [];
    const daySet = new Set(daysOfWeek.map(d => d - 1)); // Adjusting 1-based to 0-based

    let current = new Date(start);
    while (current <= end) {
      if (daySet.has(current.getDay())) {
        selectedDates.push(new Date(current));
      }
      current.setDate(current.getDate() + 1);
    }

    return selectedDates;
  }

  private getActiveMarketDays(element: any): number[] {
    const map: { [key: string]: number } = {
      Sunday: 1, Monday: 2, Tuesday: 3, Wednesday: 4,
      Thursday: 5, Friday: 6, Saturday: 7
    };
    return Object.entries(map)
      .filter(([key]) => element[key])
      .map(([, value]) => value);
  }

  private getCurrentMarketDayFlags(data: any): Record<string, boolean> {
    return {
      Sunday: !!data.Sunday,
      Monday: !!data.Monday,
      Tuesday: !!data.Tuesday,
      Wednesday: !!data.Wednesday,
      Thursday: !!data.Thursday,
      Friday: !!data.Friday,
      Saturday: !!data.Saturday
    };
  }

  private hasAnyMatchingDay(element: any, flags: Record<string, boolean>): boolean {
    return Object.keys(flags).some(day => element[day] && flags[day]);
  }

  nodeClick(event): void {
    var args;
    if (event.target) {
      const nodeId = event.target.id == "" ? 'node_' + event.target.innerHTML : event.target.id.replace('_content', '');
      args = this.diagram.getObject(nodeId.replace("&amp;", "&")) as NodeModel;
    }
    else {
      const nodeId = event.element.properties.id;
      if (nodeId && nodeId.includes('mark')) {
        const mainNodeId = nodeId.replace('mark', '').replace("_amper_", "&").replace("&amp;", "&");
        args = this.diagram.getObject(mainNodeId) as NodeModel;
      }
    }
    if (args.properties.addInfo) {
      if (args.properties.addInfo.name == "booth" && args.properties.addInfo.status == "A") {
        this.operationRentalService.getRecordFromTemp().subscribe(async (response: any[]) => {
          const dataFromTemp = response;
          const nodeId = args.properties.id;
          var selectedBooth = this.allBooths.filter(e => e.BoothNumber == args.properties.annotations[0].properties.content);
          this.BoothNumber = args.properties.annotations[0].properties.content;
          this.BoothType = selectedBooth[0]?.BoothType;
          const selectedNode = this.diagram.getObject(nodeId) as NodeModel;
          var boothIndex = this.selectedBoothData.findIndex(e => e.BoothNumber == args.properties.annotations[0].properties.content);
          if (boothIndex == -1) {
            const diagramNode: NodeModel = {
              id: nodeId.replace("&", "_amper_") + "mark",
              offsetX: selectedNode.offsetX,
              offsetY: selectedNode.offsetY,
              width: selectedNode.width / 2,
              height: selectedNode.height / 2,
              shape: {
                type: "HTML",
                content: `<div style="width:${selectedNode.width / 2}px; height: ${selectedNode.height / 2}px">
                <svg width="100%" height="100%" xmlns="http://www.w3.org/2000/svg" style="display: block; margin: 0; padding: 0;">
                    <line x1="0" y1="0" x2="100%" y2="100%" stroke="black" stroke-width="2"/>
                    <line x1="100%" y1="0" x2="0" y2="100%" stroke="black" stroke-width="2"/>
                </svg>
            </div>`
              },
              constraints: NodeConstraints.Default & ~(NodeConstraints.Drag),
            };

            var boothSelectedByOtherUser = false;
            if (this.rentalType == "D") {
              if (dataFromTemp.length > 0) {
                this.checkBoothSelectedBuyUserForDaily(dataFromTemp, selectedBooth)
              }
              if (boothSelectedByOtherUser) {
                Swal.fire({
                  text: $localize`This booth has been already selected by another user`,
                  icon: "warning",
                  confirmButtonText: $localize`Ok`,
                });
              } else {
                this.diagram.add(diagramNode);
              }
            }
            else if (this.rentalType == "CM") {
                const rentalDates: { startDate: string }[] = [];
                let rentalStartDate: string | undefined;
                const marketDays = this.LayoutData.monthlyRentalMarketDays;
                const startDate = new Date(this.LayoutData.RentalStartDate);

                const [endMonthName, endMonthYear] = this.LayoutData.monthlyRentalEndDate.split(' ');
                const endMonthIndex = this.getMonthIndex(endMonthName);
                const endDate = new Date(+endMonthYear, endMonthIndex + 1, 0);

                const formattedRentalDates = this.getMarketDatesBetween(startDate, endDate, marketDays);
                rentalDates.push(...formattedRentalDates.map(d => ({ startDate: this.datePipe.transform(d, 'MMM d, y')! })));
                rentalStartDate = rentalDates[0]?.startDate;

                if (dataFromTemp.length > 0) {
                  for (const element of dataFromTemp) {
                    const tempMarketDays = this.getActiveMarketDays(element);
                    const rentedBoothDates = this.getMarketDatesBetween(
                      new Date(element.StartDate),
                      new Date(element.EndDate),
                      tempMarketDays
                    ).map(d => this.datePipe.transform(d, 'MMM d, y'));

                    const currentMarketDayFlags = this.getCurrentMarketDayFlags(this.LayoutData);

                    const conflict = rentalDates.some(d => rentedBoothDates.includes(d.startDate)) &&
                      element.BoothNo === selectedBooth[0]?.BoothNumber &&
                      element.TempRecordNo !== this.LayoutData.tempRecordNo &&
                      this.hasAnyMatchingDay(element, currentMarketDayFlags);

                    if (conflict) {
                      boothSelectedByOtherUser = true;
                      break;
                    }
                  }
                }
                if (boothSelectedByOtherUser) {
                  Swal.fire({
                    text: $localize`This booth has been already selected by another user`,
                    icon: "warning",
                    confirmButtonText: $localize`Ok`,
                  });
                } else {
                  this.diagram.add(diagramNode);
                }
            }
            else {
              this.diagram.add(diagramNode);
            }

            if (this.rentalType == "D") {
              if (!boothSelectedByOtherUser) {
                this.selectedBoothData.push(
                  {
                    BoothNumber: selectedBooth[0].BoothNumber,
                    BoothType: selectedBooth[0].BoothType,
                    BoothTypeId: selectedBooth[0].BoothTypeId,
                  });
                this.noboothSelected = this.selectedBoothData.length > 0 ? false : true;
                this.insertDataToTemp(selectedBooth[0].BoothNumber, '', '', '');
                var selectedBoothsForRental = {
                  BoothNumber: selectedBooth[0].BoothNumber
                }
                this.selectedBoothsForRental.push(selectedBoothsForRental);
              }
            }
            else if (this.rentalType == "CM") {
              if (!boothSelectedByOtherUser) {
                var selectedBooth = this.allBooths.filter(e => e.BoothNumber == args.properties.annotations[0].properties.content);
                var marketDay;
                var marketDays = 0;
                const rentalDates = [];
                var currentMonthRentalDates = [];
                for (const el of this.LayoutData.monthlyRentalMarketDays) {
                  var marketDay;
                  var startDate = new Date(this.LayoutData.RentalStartDate);
                  const endMonth = this.LayoutData.monthlyRentalEndDate
                  const [endMonthDate, endMonthYear] = endMonth.split(' ');
                  const endMonthIndex = this.getMonthIndex(endMonthDate);
                  var endDate = new Date(endMonthYear, endMonthIndex + 1, 0);
                  const selectedDayOfWeek = el - 1;
                  let currentDay = new Date(startDate);
                  while (currentDay <= endDate) {
                    if (currentDay.getDay() === selectedDayOfWeek) {
                      if (!rentalstartDate) {
                        rentalstartDate = this.datePipe.transform(new Date(currentDay), 'MMM d, y');
                      }
                      marketDays += 1;
                      rentalDates.push({ startDate: this.datePipe.transform(new Date(currentDay), 'MMM d, y') });
                    }
                    currentDay.setDate(currentDay.getDate() + 1);
                  }

                  const compareDates = (a: DateString, b: DateString): number => {
                    const dateA = new Date(a.startDate.replace(/(\d+)(st|nd|rd|th)/, '$1')).getTime();
                    const dateB = new Date(b.startDate.replace(/(\d+)(st|nd|rd|th)/, '$1')).getTime();
                    return dateA - dateB;
                  };
                  const sortedDates = rentalDates.sort(compareDates);
                  currentMonthRentalDates = rentalDates;
                }

                this.selectedBoothData.push(
                  {
                    BoothNumber: selectedBooth[0].BoothNumber,
                    BoothType: selectedBooth[0].BoothType,
                    BoothTypeId: selectedBooth[0].BoothTypeId,
                    Sunday: this.LayoutData.monthlyRentalMarketDays.includes(1) ? true : false,
                    Monday: this.LayoutData.monthlyRentalMarketDays.includes(2) ? true : false,
                    Tuesday: this.LayoutData.monthlyRentalMarketDays.includes(3) ? true : false,
                    Wednesday: this.LayoutData.monthlyRentalMarketDays.includes(4) ? true : false,
                    Thursday: this.LayoutData.monthlyRentalMarketDays.includes(5) ? true : false,
                    Friday: this.LayoutData.monthlyRentalMarketDays.includes(6) ? true : false,
                    Saturday: this.LayoutData.monthlyRentalMarketDays.includes(7) ? true : false,
                    MarketDay: marketDay,
                    RentalStartDate: this.datePipe.transform(new Date(this.LayoutData.RentalStartDate), 'MMM d, y'),
                    NoOfMarketDays: marketDays,
                    RentalEndDate: rentalDates[rentalDates.length - 1].startDate,
                    StartDateList: currentMonthRentalDates,
                    AllRentalDates: rentalDates.map(el => new Date(el.startDate))
                  });

                this.insertDataToTemp(selectedBooth[0].BoothNumber, rentalDates[0].startDate, rentalDates[rentalDates.length - 1].startDate, '');
                var selectedBoothsForCMRental = {
                  BoothNumber: selectedBooth[0].BoothNumber,
                  StartDate: rentalDates[0].startDate,
                  EndDate: rentalDates[rentalDates.length - 1].startDate,
                  Monday: this.LayoutData.Monday ? true : false,
                  Tuesday: this.LayoutData.Tuesday ? true : false,
                  Wednesday: this.LayoutData.Wednesday ? true : false,
                  Thursday: this.LayoutData.Thursday ? true : false,
                  Friday: this.LayoutData.Friday ? true : false,
                  Saturday: this.LayoutData.Saturday ? true : false,
                  Sunday: this.LayoutData.Sunday ? true : false
                }
                this.selectedBoothsForRental.push(selectedBoothsForCMRental);
                this.noboothSelected = this.selectedBoothData.length > 0 ? false : true;
              }
            }
          }
          else if (this.rentalType == "D") {
            var markedNodeId = nodeId.replace("&", "_amper_") + "mark";
            const selectedNode = this.diagram.getObject(markedNodeId) as NodeModel;
            var boothCount = 0;
            this.sharedDataService.dailyRentalSelectedDays.map(date => {
              const boothRecord = this.sharedDataService.dailyRentalSelectedBooths.filter(selectedBooth => selectedBooth.BoothNumber === this.BoothNumber && selectedBooth.RentalDay == this.datePipe.transform(date, 'MM/dd/yyy'));
              if (boothRecord.length > 0) {
                boothCount += 1;
              }
            });

            if (boothCount != 0) {
              Swal.fire({
                title: $localize`Confirm`,
                text: $localize`Are you sure you want to delete the selected Booth?`,
                icon: "question",
                showCancelButton: true,
                confirmButtonText: $localize`Yes`,
                cancelButtonText: $localize`No`,
              }).then((result) => {
                if (result.value) {
                  this.sharedDataService.dailyRentalSelectedDays.map(date => {
                    const index = this.sharedDataService.dailyRentalSelectedBooths.findIndex(selectedBooth => selectedBooth.BoothNumber === this.BoothNumber && selectedBooth.RentalDay == this.datePipe.transform(date, 'MM/dd/yyy'));
                    if (index != -1) {
                      this.diagram.remove(selectedNode);
                      this.removeBoothCharges.emit(this.sharedDataService.dailyRentalSelectedBooths[index]);
                      this.sharedDataService.dailyRentalSelectedBooths.splice(index, 1);
                      this.selectedBoothData.splice(boothIndex, 1);
                      this.noboothSelected = this.selectedBoothData.length > 0 ? false : true;
                    }
                    else {
                      const temp = {
                        TempRecordNo: this.sharedDataService.tempRecordNo.toString(),
                        BoothNo: this.BoothNumber,
                        StartDate: new Date(date),
                        RentalType: 1
                      }
                      this.deleteFromTemp(temp);
                    }
                  });
                }
              });
            }
            else {
              this.diagram.remove(selectedNode);
              this.selectedBoothData.splice(boothIndex, 1);
              this.noboothSelected = this.selectedBoothData.length > 0 ? false : true;
              this.sharedDataService.dailyRentalSelectedDays.map(date => {
                const temp = {
                  TempRecordNo: this.sharedDataService.tempRecordNo.toString(),
                  BoothNo: this.BoothNumber,
                  StartDate: new Date(date),
                  RentalType: 1
                }
                 this.deleteFromTemp(temp);
              });
            }
          }
          else if (this.rentalType == "CM") {
            var rentalstartDate;
            var markedNodeId = nodeId.replace("&", "_amper_") + "mark";
            const selectedNode = this.diagram.getObject(markedNodeId) as NodeModel;
            const index = this.LayoutData.monthlyRentalSelectedBooths.findIndex(selectedBooth => selectedBooth.BoothNumber === this.BoothNumber && selectedBooth.RentStartPeriod == this.LayoutData.monthlyRentalSelectedBooths[0].RentStartPeriod && selectedBooth.RentEndPeriod == this.LayoutData.monthlyRentalSelectedBooths[0].RentEndPeriod);
            if (index != -1) {
              Swal.fire({
                title: $localize`Confirm`,
                text: $localize`Are you sure you want to delete the selected Booth?`,
                icon: "question",
                showCancelButton: true,
                confirmButtonText: $localize`Yes`,
                cancelButtonText: $localize`No`,
              }).then((result) => {
                if (result.value) {
                  this.diagram.remove(selectedNode);
                  this.removeBoothCharges.emit(this.LayoutData.monthlyRentalSelectedBooths[index]);
                  this.LayoutData.monthlyRentalSelectedBooths.splice(index, 1);
                  this.selectedBoothData.splice(boothIndex, 1);
                  this.noboothSelected = this.selectedBoothData.length > 0 ? false : true;
                  const startDate = new Date(this.LayoutData.RentalStartDate);
                  const endMonth = this.LayoutData.monthlyRentalEndDate
                  const [endMonthDate, endMonthYear] = endMonth.split(' ');
                  const endMonthIndex = this.getMonthIndex(endMonthDate);
                  const endDate = new Date(endMonthYear, endMonthIndex + 1, 0);
                  const rentalDates = [];
                  var rentalstartDate = "";
                  this.LayoutData.monthlyRentalMarketDays.map((el, i) => {
                    const selectedDayOfWeek = el - 1;
                    let currentDay = new Date(startDate);
                    while (currentDay <= endDate) {
                      if (currentDay.getDay() === selectedDayOfWeek) {
                        if (!rentalstartDate) {
                          rentalstartDate = this.datePipe.transform(new Date(currentDay), 'MMM d, y');
                        }
                        marketDays += 1;
                        rentalDates.push({ startDate: this.datePipe.transform(new Date(currentDay), 'MMM d, y') });
                      }
                      currentDay.setDate(currentDay.getDate() + 1);
                    }
                  });
                  const compareDates = (a: DateString, b: DateString): number => {
                    const dateA = new Date(a.startDate.replace(/(\d+)(st|nd|rd|th)/, '$1')).getTime();
                    const dateB = new Date(b.startDate.replace(/(\d+)(st|nd|rd|th)/, '$1')).getTime();
                    return dateA - dateB;
                  };
                  const sortedDates = rentalDates.sort(compareDates);
                  const temp = {
                    TempRecordNo: this.LayoutData.tempRecordNo.toString(),
                    BoothNo: this.BoothNumber,
                    StartDate: new Date(rentalDates[0].startDate),
                    RentalType: 4,
                    EndDate: new Date(rentalDates[rentalDates.length - 1].startDate),
                    Monday: this.LayoutData.Monday ? true : false,
                    Tuesday: this.LayoutData.Tuesday ? true : false,
                    Wednesday: this.LayoutData.Wednesday ? true : false,
                    Thursday: this.LayoutData.Thursday ? true : false,
                    Friday: this.LayoutData.Friday ? true : false,
                    Saturday: this.LayoutData.Saturday ? true : false,
                    Sunday: this.LayoutData.Sunday ? true : false
                  }
                   this.deleteFromTemp(temp);
                }
              });
            }
            else {
              this.diagram.remove(selectedNode);
              this.selectedBoothData.splice(boothIndex, 1);
              this.noboothSelected = this.selectedBoothData.length > 0 ? false : true;
              const startDate = new Date(this.LayoutData.RentalStartDate);
              const endMonth = this.LayoutData.monthlyRentalEndDate
              const [endMonthDate, endMonthYear] = endMonth.split(' ');
              const endMonthIndex = this.getMonthIndex(endMonthDate);
              const endDate = new Date(endMonthYear, endMonthIndex + 1, 0);
              const rentalDates = [];
              rentalstartDate = "";
              this.LayoutData.monthlyRentalMarketDays.map((el, i) => {
                const selectedDayOfWeek = el - 1;
                let currentDay = new Date(startDate);
                while (currentDay <= endDate) {
                  if (currentDay.getDay() === selectedDayOfWeek) {
                    if (!rentalstartDate) {
                      rentalstartDate = this.datePipe.transform(new Date(currentDay), 'MMM d, y');
                    }
                    marketDays += 1;
                    rentalDates.push({ startDate: this.datePipe.transform(new Date(currentDay), 'MMM d, y') });
                  }
                  currentDay.setDate(currentDay.getDate() + 1);
                }
                const compareDates = (a: DateString, b: DateString): number => {
                  const dateA = new Date(a.startDate.replace(/(\d+)(st|nd|rd|th)/, '$1')).getTime();
                  const dateB = new Date(b.startDate.replace(/(\d+)(st|nd|rd|th)/, '$1')).getTime();
                  return dateA - dateB;
                };
                const sortedDates = rentalDates.sort(compareDates);
              });
              const temp = {
                TempRecordNo: this.LayoutData.tempRecordNo.toString(),
                BoothNo: this.BoothNumber,
                StartDate: new Date(rentalDates[0].startDate),
                RentalType: 4,
                EndDate: new Date(rentalDates[rentalDates.length - 1].startDate),
                Monday: this.LayoutData.Monday ? true : false,
                Tuesday: this.LayoutData.Tuesday ? true : false,
                Wednesday: this.LayoutData.Wednesday ? true : false,
                Thursday: this.LayoutData.Thursday ? true : false,
                Friday: this.LayoutData.Friday ? true : false,
                Saturday: this.LayoutData.Saturday ? true : false,
                Sunday: this.LayoutData.Sunday ? true : false
              }
              this.deleteFromTemp(temp);
            }
          }
        });
      };
    }
  }

  getDaysDifference(date1: Date, date2: Date): number {
    // Normalize both dates to start of the day (midnight)
    const start = new Date(date1.getFullYear(), date1.getMonth(), date1.getDate());
    const end = new Date(date2.getFullYear(), date2.getMonth(), date2.getDate());
    // Calculate the difference in time (milliseconds)
    const timeDiff = Math.abs(end.getTime() - start.getTime());
    // Convert time difference from milliseconds to days
    const dayDiff = Math.ceil(timeDiff / (1000 * 3600 * 24));
    return dayDiff;
  }

  insertDataToTemp(BoothNumber, RentalStartDate, RentalEndDate, el) {
    var tempData = [];
    if (this.rentalType == "D") {
      this.sharedDataService.dailyRentalSelectedDays.forEach(date => {
        tempData.push({
          BoothNo: BoothNumber,
          TempRecordNo: this.sharedDataService.tempRecordNo.toString(),
          StartDate: new Date(date),
          EndDate: new Date(date),
          Sunday: new Date(date).getDay() == 0 ? true : false,
          Monday: new Date(date).getDay() == 1 ? true : false,
          Tuesday: new Date(date).getDay() == 2 ? true : false,
          Wednesday: new Date(date).getDay() == 3 ? true : false,
          Thursday: new Date(date).getDay() == 4 ? true : false,
          Friday: new Date(date).getDay() == 5 ? true : false,
          Saturday: new Date(date).getDay() == 6 ? true : false,
          RentalRenewal: true,
          BoothSearch: true,
          IsOnline: false
        });
      });
    }
    else if (this.rentalType == "CM") {
      tempData.push({
        BoothNo: BoothNumber,
        TempRecordNo: this.LayoutData.tempRecordNo.toString(),
        StartDate: new Date(RentalStartDate),
        EndDate: new Date(RentalEndDate),
        Monday: this.LayoutData.Monday ? true : false,
        Tuesday: this.LayoutData.Tuesday ? true : false,
        Wednesday: this.LayoutData.Wednesday ? true : false,
        Thursday: this.LayoutData.Thursday ? true : false,
        Friday: this.LayoutData.Friday ? true : false,
        Saturday: this.LayoutData.Saturday ? true : false,
        Sunday: this.LayoutData.Sunday ? true : false,
        RentalRenewal: true,
        BoothSearch: true,
        IsOnline: false
      });
    }
    this.subscriptions.push(this.operationRentalService.insertDataToTemp(tempData).subscribe((res: any) => {
    }));
  }

  getMonthIndex(monthString: string): number {
    const months = [
      'January', 'February', 'March', 'April', 'May', 'June',
      'July', 'August', 'September', 'October', 'November', 'December'
    ];
    const monthIndex = months.findIndex(month => month.toLowerCase() === monthString.toLowerCase());
    return monthIndex !== -1 ? monthIndex : 0;
  }

  async getBuildingForLayout() {
    this.loaderIcon = Promise.resolve(true);
    this.allExistingBuilding = [];
    const res = await this.layoutService.getBuildingAreasInLayOut(this.partId).toPromise();
    this.allExistingBuilding = res;
    let data = res;
    if (data.length > 0) {
      for (const item of data) {
        const nodeId = 'node_building' + item.BuildingId;
        const diagramNode: NodeModel = {
          id: nodeId,
          shape: {
            type: 'Basic',
            shape: this.boothShapes.filter(e => e.Id == item.ShapeId)[0].Name
          },
          style: {
            fill: item.BuildingBackColor != 0 ? this.convertColor(item.BuildingBackColor) : "#000",
            strokeColor: item.BuildingBackColor != 0 ? this.convertColor(item.BuildingBorderColor) : "#000",
            strokeWidth: 1,
            fontSize: item.BuildingFontSize,
            textWrapping: 'Wrap',
            fontFamily: this.fontName.filter(e => e.Id == item.BuildingFontNameId)[0].Name
          },
          annotations:
            [{
              content: item.Caption,
              style: {
                fontSize: item.BuildingFontSize,
                fontFamily: this.fontName.filter(e => e.Id == item.BuildingFontNameId)[0].Name,
                textWrapping: 'Wrap',
                bold: this.fontStyle.filter(e => e.Id == item.BuildingFontStyleId)[0].Name.toLowerCase().includes('bold'),
                italic: this.fontStyle.filter(e => e.Id == item.BuildingFontStyleId)[0].Name.toLowerCase().includes('italic')
              },
              constraints: AnnotationConstraints.ReadOnly
            }],
          width: item.BuildingWidth * 3,
          height: item.BuildingLength * 3,
          addInfo: {
            allowDrag: false, // Enable drag-and-drop for this shape
            id: item.BuildingId,
            name: 'building'
          },
          constraints: NodeConstraints.Default & ~(NodeConstraints.Drag),
          offsetX: item.LeftCoordinate,
          offsetY: item.TopCoordinate,
          rotateAngle: item.RotateAngle ? item.RotateAngle : item.BuildingVerticalDisplay == true ? 90 : 0
        };
        this.diagram.add(diagramNode);
      }
    }
    this.loaderIcon = Promise.resolve(false);
  }

  async getImagesForLayout() {
    this.loaderIcon = Promise.resolve(true);
    const response = await this.layoutService.getLayoutImages(this.partId).toPromise();
    if (response) {
      let data = response;
      if (data.length > 0) {
        for (let i = 0; i < data.length; i++) {
          let node = {
            id: 'node_images' + data[i].ImagesForLayoutId,
            addInfo: {
              status: this.layoutImages.filter(e => e.ImageId == data[i].LayoutImagesId)[0].ImagePath,
              id: data[i].ImagesForLayoutId,
              name: "image",
              ImageId: data[i].LayoutImagesId,
            },
            style: {
              strokeWidth: 0
            },
            annotations: [
              {
                //    content: this.layoutImages.filter(e => e.ImageId == data[i].LayoutImagesId)[0].ImageName,
                constraints: AnnotationConstraints.ReadOnly,
                offset: { x: 0.05, y: -0.07 }
              }
            ],
            constraints: NodeConstraints.Default & ~(NodeConstraints.Drag),
            shape: { type: 'Image', shape: 'Image' } as ImageModel, // Type assertion to ImageModel
            width: data[i].ImageWidth * 3,
            height: data[i].ImageLength * 3,
            offsetX: data[i].ImageLeftCoordinate,
            offsetY: data[i].ImageTopCoordinate,
          };

          if ((node.shape as { type: string }).type === 'Image') {
            (node.shape as ImageModel).source = node.addInfo.status;
          }

          this.diagram.add(node);
        }
        this.loaderIcon = Promise.resolve(false);
      }
    }
    this.loaderIcon = Promise.resolve(false);
  }

  getImages() {
    this.loaderIcon = Promise.resolve(true);
    const sub = this.layoutService.getImages().subscribe((res: any) => {
      if (res) {
        this.layoutImages = res;
        let data = this.layoutImages;
        if (this.layoutImages.length > 0) {
          for (let i = 0; i < this.layoutImages.length; i++) {
            const nodeId = 'node_' + data[i].ImageId;
            let node = {
              id: nodeId, addInfo: {
                status: data[i].ImagePath, id: 'z' + data[i].ImageId, name: "image", ImageId: data[i].ImageId,
              },
              annotations: [{ content: data[i].ImageName, constraints: AnnotationConstraints.ReadOnly, offset: { x: 0.5, y: -0.07 } }],
              shape: { type: 'Image', shape: 'Image' },
              width: 50, height: 50, offsetX: 50, offsetY: 50,
            };
            if (node.shape.type === 'Image') {
              (node.shape as ImageModel).source = node.addInfo.status;
            }
            this.images.push(node);
          }

          this.palettes = [
            {
              id: 'Images',
              expanded: true,
              symbols: this.images,
              title: 'Images'
            },
          ]
        }
      }
      this.loaderIcon = Promise.resolve(false);
    }, err => {
      this.loaderIcon = Promise.resolve(false);
    });
    this.subscriptions.push(sub);
  }

  layoutZoomInClick(event) {
    let zoomOptions: ZoomOptions = {
      type: "ZoomIn",
      zoomFactor: 0.2
    }
    if (event.detail > 0) {
      this.diagram.zoomTo(zoomOptions)
    }
  }

  layoutZoomOutClick(flag = false) {
    let zoomOptions: ZoomOptions = {
      type: "ZoomOut",
      zoomFactor: 0.2
    }
    if (flag) {
      this.diagram.zoomTo(zoomOptions)
    }
  }

  searchNodes(): void {
    const nodes = this.diagram.nodes as any[];
    var nodeExist = false
    this.stopBlinking();
    if (this.layoutForm.controls['layoutDiagramFilter'].value['searchBooth']) {
      nodes.forEach(node => {
        if (node.properties.addInfo.name == "booth") {
          if (node.annotations && node.annotations[0].content.toLowerCase() == this.layoutForm.controls['layoutDiagramFilter'].value['searchBooth'].toLowerCase()) {
            this.blinkingNode = node.id;
            this.startBlinking();
            nodeExist = true;
          }
        }
      });
      if (!nodeExist)
        Swal.fire({
          title: $localize`Warning`,
          text: $localize`There is no booth having this number`,
          icon: "warning",
          confirmButtonText: $localize`Ok`,
        });
    }
    else {
      Swal.fire({
        title: $localize`Warning`,
        text: $localize`Please enter the booth number to search`,
        icon: "warning",
        confirmButtonText: $localize`Ok`,
      });
    }
  }

  changeSearchText() {
    if (this.layoutForm.controls['layoutDiagramFilter'].value['searchBooth'] == '') {
      this.stopBlinking();
    }
  }

  startBlinking(): void {
    this.stopBlinking(); // Ensure no previous intervals are running

    this.blinkInterval = setInterval(() => {
      const node = this.diagram.getObject(this.blinkingNode) as NodeModel;
      if (node) {
        node.style.fill = node.style.fill === 'red' ? 'transparent' : 'red';
        this.diagram.dataBind();
      }
    }, 500); // Blink every 500 milliseconds

    setTimeout(() => {
      this.stopBlinking();
      this.layoutForm.controls['layoutDiagramFilter'].get('searchBooth').setValue('');
    }, 5000); // Stop blinking after 5 seconds
  }

  stopBlinking(): void {
    if (this.blinkInterval) {
      clearInterval(this.blinkInterval);
      this.blinkInterval = null;

      const node = this.diagram.getObject(this.blinkingNode) as NodeModel;
      if (node) {
        const nodeId = node.id.replace("node_", "");
        const boothData = this.allBooths.find(item => item.BoothNumber == nodeId);
        if (boothData) {
          const fontColor = boothData.Status.toLowerCase() == "r" ? "#fff" : "#000";
          node.style.fill = this.convertColor(boothData.BackColor);
          node.style.strokeColor = this.convertColor(boothData.BorderColor);
          this.diagram.dataBind();
        }
      }
    }
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((subscription) => {
      if (subscription) {
        subscription.unsubscribe();
      }
    });
  }
}
